/**
 * @author [zhaowenjie08]
 * @email [zhaowenjie08@58.com]
 * @create date 2022-06-23 17:20:32
 * @modify date 2022-06-23 17:20:32
 * @desc [门店主应用api重构]
 */
import request from '@/utils/request'

// 获取登录相关信息
export function getLoginInfo () {
  return request.get('/api/login/getLoginInfo')
}

// 菜单
export function getMenu () {
  return request.get('/api/menu/getMenu')
}

/**
 * 查询灰度信息
 * @param scene 灰度场景名称
 * @returns Y | N
 */
export function getGrayInfo (scene: string) {
  return request.get('/api/node/gray/gateway/status', {
    params: {
      scene
    }
  })
}

/**
 * 查询强制下线ui切换入口的灰度信息
 */
export function getNewLayoutGrayInfo () {
  return request.get('/api/common/local/versionSwitch ')
}
